import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  loadingPaper: {
    height: '400px',
  },
});
